import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {MonthlyReportForClient} from "../monthly-report-for-client.model";

export class MonthlyReportForClientDgSearchResults extends GenericDgSearchResults {
  public results: MonthlyReportForClient[];

  constructor(total: number, results: MonthlyReportForClient[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

